/**
 * Geolocation capture. One-shot permission prompt; result cached in localStorage.
 * Anonymous and optional — the app works perfectly without it.
 */

const KEY = 'loveall:geo';
const ASKED_KEY = 'loveall:geo_asked';

export function getCachedGeo() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function hasAskedLocation() {
  return localStorage.getItem(ASKED_KEY) === '1';
}

/**
 * Request the browser's location permission and cache the result.
 * Resolves with { lat, lng, accuracy, granted: true } or { granted: false, reason }.
 */
export function requestLocation({ silent = false } = {}) {
  return new Promise((resolve) => {
    if (!('geolocation' in navigator)) {
      const result = { granted: false, reason: 'unavailable' };
      localStorage.setItem(KEY, JSON.stringify(result));
      localStorage.setItem(ASKED_KEY, '1');
      resolve(result);
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const result = {
          granted: true,
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          accuracy: pos.coords.accuracy,
          ts: Date.now(),
        };
        localStorage.setItem(KEY, JSON.stringify(result));
        localStorage.setItem(ASKED_KEY, '1');
        resolve(result);
      },
      (err) => {
        const result = { granted: false, reason: err?.message || 'denied' };
        localStorage.setItem(KEY, JSON.stringify(result));
        localStorage.setItem(ASKED_KEY, '1');
        if (!silent && process.env.NODE_ENV !== 'production') {
          console.debug('[geo] denied:', err?.message);
        }
        resolve(result);
      },
      { enableHighAccuracy: false, timeout: 8000, maximumAge: 300000 }
    );
  });
}
